import React, { Dispatch, SetStateAction } from "react";
import {
  IAddress,
  ICommitteeMemberInput,
  ICooperativeDetails,
  IDeclaration,
  IDocumentsInput,
  IExecutiveMemberInput,
  IFinancialAuditInput,
  IFinancialIncome,
  IFinancialLoan,
  IFinancialShare,
  IShareMemberInput,
} from "../../exports/interfaces";

const Review = ({
  cooperativeInfo,
  address,
  shareFinancial,
  loanFinancial,
  incomeFinancial,
  auditFinancial,
  committeeCooperative,
  executiveCooperative,
  shareMember,
  documents,
  declaration,
  setCurrentStep,
  scrollToStepper,
  edit,
}: {
  cooperativeInfo: ICooperativeDetails;
  address: IAddress;
  shareFinancial: IFinancialShare;
  loanFinancial: IFinancialLoan;
  incomeFinancial: IFinancialIncome;
  auditFinancial: IFinancialAuditInput;
  committeeCooperative: ICommitteeMemberInput;
  executiveCooperative: IExecutiveMemberInput;
  shareMember: IShareMemberInput;
  documents: IDocumentsInput;
  declaration: IDeclaration;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  scrollToStepper: () => void;
  edit?: boolean;
}) => {
  const getStepClass = (status: string) => {
    switch (status) {
      case "Complete":
        return "pill-success";
      case "In-Complete":
        return "pill-warning";
      case "Not Started":
        return "pill-danger";
      default:
        return "bg-secondary-subtle text-secondary";
    }
  };

  const ignoredKeys = [
    "file",
    "fileName",
    "documentUrl",
    "bodFile",
    "bodFileName",
    "bodDocumentUrl",
  ];

  const isFilled = (obj: any) => {
    if (edit) {
      if (!obj) return false;

      return Object.entries(obj).every(([key, value]) => {
        if (
          ignoredKeys.includes(key) ||
          key.endsWith("File") ||
          key.endsWith("FileName") ||
          key.endsWith("DocumentUrl")
        ) {
          return true;
        }

        return value !== null && value !== "" && value !== undefined;
      });
    } else {
      if (!obj) return false;

      return Object.values(obj).every((val) => {
        return val !== null && val !== "" && val !== undefined;
      });
    }
  };

  const moveToStep = (step: number) => {
    setCurrentStep(step);
    scrollToStepper();
  };

  const steps = [
    {
      id: 1,
      title: "Cooperative Basic Info",
      status: isFilled(cooperativeInfo) ? "Complete" : "In-Complete",
    },
    {
      id: 2,
      title: "Cooperative Address",
      status: isFilled(address) ? "Complete" : "In-Complete",
    },
    {
      id: 3,
      title: "Cooperative Financial Details",
      status:
        isFilled(shareFinancial) &&
        isFilled(loanFinancial) &&
        isFilled(incomeFinancial) &&
        isFilled(auditFinancial)
          ? "Complete"
          : "In-Complete",
    },
    {
      id: 4,
      title: "Cooperative Committee and Executive Details",
      status:
        isFilled(committeeCooperative) && isFilled(executiveCooperative)
          ? "Complete"
          : "In-Complete",
    },
    {
      id: 5,
      title: "Cooperative Share member Details",
      status: isFilled(shareMember) ? "Complete" : "In-Complete",
    },
    {
      id: 6,
      title: "Cooperative Document",
      status: isFilled(documents) ? "Complete" : "In-Complete",
    },
    {
      id: 7,
      title: "Declaration",
      status:
        isFilled(declaration) && declaration.declaration
          ? "Complete"
          : "In-Complete",
    },
  ];
  return (
    <>
      {steps.map((step, index) => (
        <div
          className="dashboard-card mt-2 review-card"
          onClick={() => moveToStep(index)}
        >
          <div className="d-flex align-items-center justify-content-between">
            <h6>
              <span className="step-circle">{step.id}</span> {step.title}
            </h6>
            <span
              className={`badge rounded-pill px-3 py-2 ${getStepClass(
                step.status,
              )}`}
            >
              {step.status}
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

export default Review;
